// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__DNIwt","content":"ManualTimeModal_content__1_Cf5"};